import { Trash2 } from "lucide-react";
import DeskConfirm from "@/components/crm/DeskConfirm";

/** Confirmation générique d'action destructrice — R2 (iter393), ex-ModuleDialog rouge. `icon` : composant Lucide ou élément (<Trash2 />). */
export default function ConfirmDestructiveDialog({ open, onOpenChange, title = "Confirmer la suppression ?", description = "Cette action est irréversible.", icon = Trash2, body = null, warningText = null, confirmLabel = "Confirmer", busyLabel = "Suppression…", onConfirm, busy = false, testId = "confirm-destructive-dialog" }) {
  const Icon = typeof icon === "function" ? icon : icon?.type;
  return (
    <DeskConfirm open={open} title={title} busy={busy} icon={Icon} confirmLabel={busy ? busyLabel : confirmLabel}
      message={<>{description}{warningText && <><br /><span style={{ color: "#F09595" }}>{warningText}</span></>}</>}
      onClose={() => { if (!busy) onOpenChange(false); }} onConfirm={onConfirm} testId={testId}>
      {body}
    </DeskConfirm>
  );
}
